export const SET_PAYROLL_EMPLOYEE_GENERATE = 'SET_PAYROLL_EMPLOYEE_GENERATE';

export const setPayrollEmployee = (data) => (dispatch) => {
  dispatch({
    type: SET_PAYROLL_EMPLOYEE_GENERATE,
    data: data,
  });
};
